import { skipLoading } from '../../common/functions/loading';

export default {
  data() {
    return {
      workflowAjusteVerbaResource: this.$api.workflowAjusteVerba(this.$resource),
      aprovadorAtual: false,
      justificativaObrigatoria: false,
      actionJustificativa() {},
      justificativa: '',
      justificativaSomenteLeitura: false,
    };
  },
  computed: {
    exibeBtnAvaliacao() {
      return !this.novo && this.aprovadorAtual
        && this.novoAjuste.status === 'AGUARDANDO_APROVACAO';
    },
  },
  methods: {
    solicitarAprovacao() {
      const idAjuste = this.novoAjuste.id;
      this.workflowAjusteVerbaResource.iniciaFluxo({ idAjuste }, { idAjuste })
        .then(() => {
          this.$router.push({ name: this.$route.params.from || 'ajuste-verba' });
          this.$toast(this.$tc('message.ajuste_verba_enviado_aprovacao', 1));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    aprovar(justificativa) {
      const idAjuste = this.novoAjuste.id;
      this.workflowAjusteVerbaResource.aprovarPasso({ idAjuste },
        { observacao: justificativa })
        .then(() => {
          this.$router.push({ name: this.$route.params.from || 'ajuste-verba' });
          this.$toast(this.$tc('message.ajuste_verba_aprovado', 1));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    reprovar(justificativa) {
      const idAjuste = this.novoAjuste.id;
      this.workflowAjusteVerbaResource.reprovar({ idAjuste },
        { observacao: justificativa })
        .then(() => {
          this.$router.push({ name: this.$route.params.from || 'ajuste-verba' });
          this.$toast(this.$tc('message.ajuste_verba_reprovado', 1));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    enviarAnalise(justificativa) {
      const idAjuste = this.novoAjuste.id;
      this.workflowAjusteVerbaResource.enviarAnalise({ idAjuste },
        { observacao: justificativa })
        .then(() => {
          this.$router.push({ name: this.$route.params.from || 'ajuste-verba' });
          this.$toast(this.$tc('message.ajuste_verba_enviado_analise', 1));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    salvarESolicitarAprovacao() {
      if (!this.$refs.form.validate() || this.isValorInvalido) return;
      const promise = !this.novoAjuste.id
        ? this.ajusteVerbaResource.salvarAjusteVerba(this.novoAjuste)
        : this.ajusteVerbaResource.atualizarAjusteVerba(this.novoAjuste);

      promise
        .then((res) => {
          this.novoAjuste.id = res.data;
          this.solicitarAprovacao();
        }, (err) => {
          this.$toast(err.data.error);
        });
    },
    salvarEConcluir() {
      const promise = !this.novoAjuste.id
        ? this.ajusteVerbaResource.salvarAjusteVerba(this.novoAjuste)
        : this.ajusteVerbaResource.atualizarAjusteVerba(this.novoAjuste);

      promise
        .then((res) => {
          const idAjuste = res.data;
          this.novoAjuste.id = idAjuste;
          return this.ajusteVerbaResource.concluir({ idAjuste }, { idAjuste });
        })
        .then(() => {
          this.$router.push({ name: this.$route.params.from || 'ajuste-verba' });
          this.$toast(this.$tc('message.ajuste_verba_concluido', 1));
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    verificarUsuarioSolicitante() {
      const { status, idTipoVerbaDestino } = this.novoAjuste;
      if (status != null && ['EM_CADASTRO', 'EM_ANALISE', 'AGUARDANDO_APROVACAO'].indexOf(status) < 0) {
        return Promise.resolve();
      }

      skipLoading();
      return this.workflowAjusteVerbaResource.solicitante({ idTipoVerba: idTipoVerbaDestino })
        .then((response) => {
          this.novoAjuste = {
            ...this.novoAjuste,
            solicitanteFluxo: response.data.usuarioHabilitado,
          };
        });
    },
    verificarUsuarioAprovador() {
      const { status, id } = this.novoAjuste;
      if (status !== 'AGUARDANDO_APROVACAO') {
        return Promise.resolve();
      }

      skipLoading();
      return this.workflowAjusteVerbaResource.aprovador({ idAjuste: id })
        .then((response) => {
          this.aprovadorAtual = response.data.usuarioHabilitado;
        });
    },
    abrirJustificativaAprovar() {
      this.abrirJustificativaAvaliar(this.aprovar, false);
    },
    abrirJustificativaReprovar() {
      this.abrirJustificativaAvaliar(this.reprovar, true);
    },
    abrirJustificativaAnalise() {
      this.abrirJustificativaAvaliar(this.enviarAnalise, true);
    },
    abrirJustificativaAvaliar(acaoJustificativa, obrigatorio) {
      this.justificativaObrigatoria = obrigatorio;
      this.actionJustificativa = acaoJustificativa;
      this.justificativa = '';
      this.justificativaSomenteLeitura = false;
      this.$refs.modalJustificativa.open();
    },
  },
};
